import React from 'react';
import { Switch } from 'react-router-dom';
import useGWTPagesSupport from 'Application/PageContent/useGWTPagesSupport';

import useGroupsRoutes from 'Application/PageContent/routes/useGroupsRoutes';
import useMessagingRoutes from 'Application/PageContent/routes/useMessagingRoutes';
import useWorkflowsRoutes from 'Application/PageContent/routes/useWorkflowsRoutes';
import useUsersRoutes from 'Application/PageContent/routes/useUsersRoutes';
import useUserProfileRoutes from 'Application/PageContent/routes/useUserProfileRoutes';
import useServicesRoutes from 'Application/PageContent/routes/useServicesRoutes';
import useIncidentsRoutes from 'Application/PageContent/routes/useIncidentsRoutes';
import useAdminRoutes from 'Application/PageContent/routes/useAdminRoutes';
import useReportsRoutes from 'Application/PageContent/routes/useReportsRoutes';
import useDefaultRoute from '../../PageContent/routes/useDefaultRoute';

export default function PageContent() {
  const { GWTInjectPoint } = useGWTPagesSupport();
  const routes = [
    ...useIncidentsRoutes(),
    ...useServicesRoutes(),
    ...useUsersRoutes(),
    ...useGroupsRoutes(),
    ...useReportsRoutes(),
    ...useMessagingRoutes(),
    ...useWorkflowsRoutes(),
    ...useAdminRoutes(),

    ...useUserProfileRoutes(),

    useDefaultRoute(),
  ];

  return (
    <>
      {/* Note: using React.createElement(Switch, ...) instead of <Switch> in order to suppress the missing key warning 
          since routes is a stable array */}
      {React.createElement(Switch, {}, ...routes)}
      {/* GWTInjectPoint gets display: none if it's not the first-of-type to hide when 
          rendering React pages. Be careful if reordering :) */}
      <GWTInjectPoint />
    </>
  );
}

PageContent.displayName = 'PageContent';
